import { Autocomplete, Button, Grid, MenuItem, Select, TextField, IconButton, Typography, Box } from '@mui/material';
import { Form, Formik, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useState } from 'react';
import { category, countryList } from '../../assets/enums';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { suggestPackageRoute } from '../../services';
// import { closePopup } from '../../store/slices/popupSlice';
import { useAppDispatch } from '../../assets/hooks';
import { addSuggestedPackage, updateSuggestedPackage } from '../../store/slices/suggestedPackagesSlice';
import Images from '../../assets';

// Validation Schema using Yup
const validationSchema = Yup.object().shape({
    name: Yup.string().required('Package name is required'),
    description: Yup.string().required('Description is required'),
    totalPrice: Yup.number().required('Total price is required').min(0, 'Price must be greater than zero'),
    // duration: Yup.object().shape({
    //     end: Yup.date()
    //         .required('End date is required')
    //         .min(new Date(), 'End date cannot be in the past'), // Optional validation for future date
    // }),
    country: Yup.array().min(1, 'At least one country is required'),
    requirements: Yup.array().of(Yup.string().required('Requirement is required')),
    benefits: Yup.array().of(Yup.string().required('Benefit is required')),
    products: Yup.array().of(
        Yup.object().shape({
            category: Yup.string().required('Category is required'),
            quantity: Yup.number().required('Quantity is required').min(1, 'Quantity must be greater than zero')
        })
    ),
    termsAndConditions: Yup.string().required('Terms and conditions are required')
});

const SuggestPackage = (props: any) => {
    // console.log(props)
    const dispatch = useAppDispatch();
    const [countryData, setCountryData] = useState(props?.data?.package?.country || []);
    const [loading, setLoading] = useState(false);

    const eventHandler = async (event: any, setFieldValue: any) => {
        if (event.name === "countryChange") {
            setCountryData(event.data.newValue);
            setFieldValue("country", event.data.newValue);
        }
    };

    const submit = async (values: any) => {
        let data = {
            studentId: props?.data?.id,
            action: props?.data?.editMode ? "edit" : "suggest",
            data: values
        };
        setLoading(true);
        console.log("Package Submit",data);
        // console.log(data)
        try {
            const response = await suggestPackageRoute(data);
            if (response) {
                if (props?.data?.editMode) {
                    dispatch(updateSuggestedPackage(response.data.data))
                } else {
                    dispatch(addSuggestedPackage(response.data.data))

                }
            }
            setLoading(false);

        } catch (err) {
            console.log(err);
            setLoading(false);

        }
        // dispatch(closePopup());
    };

    const initialValues = props.data?.editMode
        ? {
            // Use the values passed via props if it's edit mode
            packageId: props.data?.package?._id,
            name: props.data?.package?.name,
            description: props.data?.package.description,
            totalPrice: props.data?.package.priceDetails?.totalPrice,
            currency: props.data?.package.priceDetails?.currency,
            end: props?.data?.package?.duration?.end,
            country: props.data?.package?.country,
            requirements: props.data?.package.requirements,
            benefits: props.data?.package.benefits,
            products: props.data?.package.products,
            termsAndConditions: props.data?.package.termsAndConditions,
        }
        : {
            // Default empty values for add mode
            name: "",
            description: "",
            country: [],
            totalPrice: "",
            currency: { symbol: "₹", code: "INR" },
            end: "",
            requirements: [""],
            benefits: [""],
            products: [{ category: "", quantity: "" }],
            termsAndConditions: "",
        };


    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => submit(values)}
            >
                {({ isSubmitting, values, handleChange, setFieldValue, errors, touched }) => {
                    console.log(errors)
                    return (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Package name *"
                                        name="name"
                                        type="text"
                                        size="small"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={touched.name && Boolean(errors.name)}
                                    // helperText={touched.name && errors.name}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Description *"
                                        name="description"
                                        type="text"
                                        size="small"
                                        multiline
                                        maxRows={4}
                                        value={values.description}
                                        onChange={handleChange}
                                        error={touched.description && Boolean(errors.description)}
                                    // helperText={touched.description && errors.description}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Total Price *"
                                        name="totalPrice"
                                        type="number"
                                        size="small"
                                        value={values.totalPrice}
                                        onChange={handleChange}
                                        error={touched.totalPrice && Boolean(errors.totalPrice)}
                                    // helperText={touched.totalPrice && errors.totalPrice}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="End Date *"
                                        name="end"
                                        type="date"
                                        size="small"
                                        // label="End Date *"
                                        value={values?.end}
                                        onChange={(event) => setFieldValue('end', event.target.value)}
                                    // error={touched.duration?.end && Boolean(errors.duration?.end)}
                                    // helperText={touched.duration?.end && errors.duration?.end}
                                    />
                                    <ErrorMessage name={`end`}>
                                        {msg => <div style={{ color: '#d32f2f', fontSize: "12px" }}>{msg}</div>}
                                    </ErrorMessage>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Autocomplete
                                        multiple
                                        id="autocomplete"
                                        limitTags={2}
                                        size="small"
                                        options={countryList}
                                        getOptionLabel={(option) => option}
                                        value={countryData}
                                        filterSelectedOptions
                                        ListboxProps={{
                                            style: { maxHeight: "180px", overflowY: "auto" },
                                        }}
                                        onChange={(event, newValue) =>
                                            eventHandler({
                                                name: "countryChange",
                                                data: { event, newValue },
                                            }, setFieldValue)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Search country *"
                                                variant="outlined"
                                                error={touched.country && Boolean(errors.country)}
                                            // helperText={touched.country && errors.country}
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Requirements FieldArray */}
                                <FieldArray name="requirements">
                                    {({ push, remove }) => (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography fontSize="18px" fontWeight="600">Requirements</Typography>
                                                {values.requirements.map((requirement: any, index: number) => (
                                                    <Grid container spacing={2} key={index} sx={{ mb: 1 }}>
                                                        <Grid item xs={10}>
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                placeholder="Add Requirement *"
                                                                name={`requirements[${index}]`}
                                                                value={requirement}
                                                                onChange={handleChange}
                                                                size="small"
                                                                error={Array.isArray(errors.requirements) && Boolean(errors.requirements[index])}
                                                            // helperText={errors.requirements?.[index]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <IconButton
                                                                onClick={() => remove(index)}
                                                                disabled={values.requirements.length === 1}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button onClick={() => push('')} startIcon={<AddIcon />} sx={{ textTransform: "none" }}>
                                                    Add Requirement
                                                </Button>
                                            </Grid>
                                        </>
                                    )}
                                </FieldArray>

                                {/* Benefits FieldArray */}
                                <FieldArray name="benefits">
                                    {({ push, remove }) => (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography fontSize="18px" fontWeight="600">Benefits</Typography >
                                                {values.benefits.map((benefit: any, index: number) => (
                                                    <Grid container spacing={2} key={index} sx={{ mb: 1 }}>
                                                        <Grid item xs={10}>
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                placeholder="Add Benefit *"
                                                                name={`benefits[${index}]`}
                                                                value={benefit}
                                                                onChange={handleChange}
                                                                size="small"
                                                                error={Array.isArray(errors.benefits) && Boolean(errors.benefits[index])}
                                                            // helperText={errors.benefits?.[index]}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <IconButton
                                                                onClick={() => remove(index)}
                                                                disabled={values.benefits.length === 1}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button onClick={() => push('')} startIcon={<AddIcon />} sx={{ textTransform: "none" }}>
                                                    Add Benefit
                                                </Button>
                                            </Grid>
                                        </>
                                    )}
                                </FieldArray>

                                {/* Products FieldArray */}
                                <FieldArray name="products">
                                    {({ push, remove }) => (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography fontSize="18px" fontWeight="600">Products</Typography>
                                                {values.products.map((product: any, index: number) => (
                                                    <Grid container spacing={2} key={index} sx={{ mb: 1 }}>
                                                        <Grid item xs={5}>
                                                            <Select
                                                                fullWidth
                                                                variant="outlined"
                                                                name={`products[${index}].category`}
                                                                value={product.category}
                                                                onChange={handleChange}
                                                                size="small"
                                                                defaultValue=''
                                                                displayEmpty
                                                            // error={Boolean(errors.products?.[index] && errors.products?.[index]?.category)}
                                                            >
                                                                <MenuItem value="">
                                                                    Select category *
                                                                </MenuItem>
                                                                {category.map((value) => (
                                                                    <MenuItem key={value} value={value}>
                                                                        {value}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <ErrorMessage name={`products[${index}].category`}>
                                                                {msg => <div style={{ color: '#d32f2f', fontSize: "12px" }}>{msg}</div>}
                                                            </ErrorMessage>
                                                        </Grid>

                                                        <Grid item xs={5}>
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                name={`products[${index}].quantity`}
                                                                value={product.quantity}
                                                                onChange={handleChange}
                                                                size="small"
                                                                placeholder='Enter quantity *'
                                                            // error={Boolean(errors.products?.[index] && errors.products?.[index]?.quantity)}
                                                            />
                                                            <ErrorMessage name={`products[${index}].quantity`}>
                                                                {msg => <div style={{ color: '#d32f2f', fontSize: "12px" }}>{msg}</div>}
                                                            </ErrorMessage>
                                                        </Grid>

                                                        <Grid item xs={2}>
                                                            <IconButton
                                                                onClick={() => remove(index)}
                                                                disabled={values.products.length === 1}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button onClick={() => push({ category: "", quantity: "" })} startIcon={<AddIcon />} sx={{ textTransform: "none" }}>
                                                    Add Product
                                                </Button>
                                            </Grid>
                                        </>
                                    )}
                                </FieldArray>


                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Terms and Conditions *"
                                        name="termsAndConditions"
                                        type="text"
                                        size="small"
                                        multiline
                                        rows={2}
                                        value={values.termsAndConditions}
                                        onChange={handleChange}
                                        error={touched.termsAndConditions && Boolean(errors.termsAndConditions)}
                                    // helperText={touched.termsAndConditions && errors.termsAndConditions}
                                    />
                                </Grid>

                                <Grid item xs={12} sx={{ textAlign: "right" }}>
                                    <Button type="submit" sx={{
                                        color: "#fff",
                                        background: "#3B3F76",
                                        borderRadius: "5px",
                                        textTransform: "none",
                                        fontSize: "0.8rem",
                                        "&:hover": {
                                            background: "#3B3F76",
                                        },
                                    }}>
                                        {loading ? (
                                            <Box
                                                component="img"
                                                src={Images.standardLoader}
                                                alt="standardLoader"
                                                sx={{ width: "1rem", height: "1rem" }}
                                            />
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default SuggestPackage;
